// extracted by mini-css-extract-plugin
export var logos = "logos-module--logos--6r1aA";
export var list = "logos-module--list--Df0wQ";
export var jsAnimInit = "logos-module--jsAnimInit--qhtLn";
export var item = "logos-module--item--3y9rs";